export const TEST_ID_MOBILE_SUMMARY_FLIGHTS_TYPE =
  'mobile-summary-flights-type';
